import { ReceivingDebtContainer } from "../../../containers/borrowSystem/Contact/ReceivingDebtContainer";
export function ReceivingDebtPage () {
    return(
        <ReceivingDebtContainer/>
    )
}